<div *ngIf="hasPolicies(); else noPolicies">
    <app-policy-summary
        *ngFor="let policy of policies"
        [policy]="policy"
    ></app-policy-summary>
    
</div>
<ng-template #noPolicies>
    <div class="card bg-card">
        <div
            class="cart-container flex flex-column align-items-center justify-content-center"
        >
            <img
                class="w-5rem h-5rem"
                src="../../../../assets/demo/images/checklist.gif"
            />
            <span class="text-xl mt-4 mb-2">{{
                "You do not have policies yet" | translate
            }}</span>
            <span class="text-sm text-500"
                ><a href="/home/quotations">{{ "CLICK_HERE" | translate }}</a>
                {{ "to get a quotation" | translate }}</span
            >
        </div>
    </div>
</ng-template>
